export default __webpack_public_path__ + "static/media/Platformer.16b36b27.svg";